export const iOS =
  navigator.userAgent.indexOf("iPhone") !== -1 ||
  navigator.userAgent.indexOf("iPad") !== -1;
